{
  "DEFAULT_OOPS_TITLE": "OOPS! An error occurred.",
  "DEFAULT_OOPS_DESCRIPTION": "Try again later or contact your AE.",
  "TOAST_SUCCESS_TITLE": "Successfully saved",
  "TOAST_INFO_TITLE": "Info",
  "TOAST_ERROR_DESCRIPTION_UNDERWRITER": "Try again. If this issue persists submit a ticket via YouSupport.",
  "TOAST_ERROR_STATUS": "error",
  "TOAST_INFO_STATUS": "info",
  "TOAST_WARNING_STATUS": "warning",
  "TOAST_SUCCESS_STATUS": "success",
  "NOT_AVAILABLE": "N/A",
  "LOADER_MESSAGE": {
    "EMPTY": "",
    "DEFAULT": "Let's get that for you...",
    "UPDATING": "Updating..."
  },
  "PRODUCT_TYPE": {
    "CONVENTIONAL": "Conventional",
    "FHA": "FHA",
    "VA": "VA",
    "USDA": "USDA"
  },
  "HEADER_TITLES": {
    "TITLE_COMMITMENT": "Title Commitment",
    "PRE_CLOSING_STATUS_REPORT": "Pre-Closing Status Report",
    "WIRE_INSTRUCTIONS": "Wire Instructions",
    "CPL": "Closing Protection Letter/E & O",
    "CIL": "Closing Indemnification Letter",
    "SELLER_ACQUISITION": "Seller Acquisition",
    "VALIDATE_PAYSTUB": "Validate Paystub",
    "CALCULATE_PAYSTUB": "Calculate Paystub",
    "CONTRACT_REVIEW": "Contract Review",
    "HOME_OWNER_INSURANCE": "Homeowner Insurance",
    "SUBJECT_PROPERTY_OCCUPANCY": "Subject Property Occupancy"
  },
  "LOAN_TAB_LOCK_MESSAGE": "This loan is open in another page. As a result, BOLT will be read-only in this window.",
  "LOAN_TAB_LOCK_BY_USER_MESSAGE": "{{lockedByUser}} is currently viewing this loan in another page. As a result, BOLT will be read-only in this window.",
  "LOAN_STATUS_COUNTEROFFERS_GUIDELINE_LINK": "https://thesource.uwm.com/search-guidelines/uwm-documents/underwriting/loanstatusandcounteroffersguideund#suspense"
}
